var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var buttonElement = require('../components/button');
var permissionModal = modalForm(require('./models/permission'));
var edit = require('../layout/components/edit');
var pathHeader = require('../layout/components/pathHeader');
var equipmentModel = require('../equipment/models/equipment');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var dragscroll = require('../libs/dragscroll');
var groupPermissionModal = require('./components/editGroupPermissionsModal');
var rowActionDropdown = require('../components/rowActionDropdown');
var permissionGroupFilter = require('../libs/permissionGroupFilter');
var pageRequestState = require('../layout/components/pageRequestState');

var page = {};

page.oninit = function () {
  var ctrl = this;

  ctrl.dashboard = prop({});
  ctrl.permissions = prop([]);
  ctrl.groups = prop();
  ctrl.fakeNode = prop({'@rid': '01', 'name': 'Permissions'});
  ctrl.newNode = prop(false);
  ctrl.permissionsToShow = [];
  ctrl.routeId = m.route.param('id');
  ctrl.saveError = prop('');
  pageRequestState.initialize(ctrl);

  ctrl.isCurrentRoute = function (routeId) {
    return ctrl.routeId === routeId;
  };

  ctrl.reset = function () {
    ctrl.dashboard({});
    ctrl.permissions([]);
    ctrl.permissionsToShow = [];
    ctrl.newNode(false);
  };

  ctrl.init = function () {
    var routeId = ctrl.routeId;
    return pageRequestState.run(ctrl, function () {
      return Promise.all([
        loaders.requestWithLoader({
          url: '/api/v1/site/' + routeId,
          method: 'GET',
          background: true
        })
        .then( dashboard => {
          if (ctrl.isCurrentRoute(routeId)) {
            ctrl.dashboard(dashboard);
            ctrl.dashboard().path.reverse();
            ctrl.dashboard().path.push(ctrl.fakeNode());
          }
        }),
        loaders.requestWithLoader({
          url: '/api/v1/site/' + routeId + '/permissions',
          method: 'GET',
          background: true,
        })
        .then(function (records) {
          if (!ctrl.isCurrentRoute(routeId)) {
            return;
          }
          ctrl.permissions(records.map(r => {
            r.dashboard = '#' + routeId;
            r.group = r.in;
            r.groupName = r.in.name;
            return r;
          }));
        }),
        loaders.requestWithLoader({
          url: '/api/v1/group/',
          method: 'GET',
          background: true
        })
        .then( groups => {
          ctrl.groups(groups)
        })
      ])
      .then(() => {
        if (ctrl.isCurrentRoute(routeId)) {
          ctrl.newNode(true);
          m.redraw();
        }
      })
    }, { errorMessage: 'Unable to load location permissions:' });
  };

  modal.on('closed', ctrl.init);
  
  ctrl.init();


  ctrl.updatePermissions = (permissionRecord)=>{
    let readAll = document.getElementById('check_readAll'+ permissionRecord['@rid']).checked && 
      !document.getElementById('check_readAll'+ permissionRecord['@rid']).disabled ? 1 : 0;
    let writeAll = document.getElementById('check_writeAll'+ permissionRecord['@rid']).checked && 
      !document.getElementById('check_writeAll'+ permissionRecord['@rid']).disabled ? 1 : 0;
    let readPermissionValues = equipmentModel.equipmentClassTree.categories.filter(r =>  r.name != 'Overview').map((category, idx) => {
      let key = `${category.name}Read`
      return {[key]: document.getElementById(`check_read${category.name}`+ permissionRecord['@rid']).checked  && !document.getElementById(`check_read${category.name}`+ permissionRecord['@rid']).disabled ? 1 : 0}
    })

    let writePermissionValues = equipmentModel.equipmentClassTree.categories.filter(r =>  r.name != 'Overview').map((category, idx) => {
      let key = `${category.name}Write`
      return {[key]: document.getElementById(`check_write${category.name}`+ permissionRecord['@rid']).checked  && !document.getElementById(`check_write${category.name}`+ permissionRecord['@rid']).disabled ? 1 : 0}
    })

    let body = {
      dashboard: permissionRecord.out['@rid'],
      group: permissionRecord.in['@rid'],
      read: readAll,
      write: writeAll
    }
    readPermissionValues.forEach(r=> body[Object.keys(r)[0]] = r[Object.keys(r)[0]])
    writePermissionValues.forEach(r=> body[Object.keys(r)[0]] = r[Object.keys(r)[0]])


    Object.keys(body).forEach((key) => {
      if (key.startsWith("parent")) {
        delete body[key];
      }
    });
    
    ctrl.saveError('');
    return loaders.requestWithLoader({
      url: '/api/v1/permission/'+ permissionRecord['@rid'].slice(1),
      method: 'PUT',
      body,
    })
    .then(function () {
      return ctrl.init();
    })
    .catch(function (error) {
      console.error('Unable to update location permissions:', error);
      ctrl.saveError((error && (error.error || error.message)) || 'Unable to update permissions. Please try again.');
      m.redraw();
      return null;
    });

  }
};

page.onbeforeupdate = function () {
  var ctrl = this;
  var nextRouteId = m.route.param('id');

  if (!nextRouteId || ctrl.routeId === nextRouteId) {
    return true;
  }

  ctrl.routeId = nextRouteId;
  ctrl.reset();
  ctrl.init();
  return true;
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function (vnode) {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.groups() || !ctrl.dashboard().path) return
  return m('div', {class:'container'}, [
    ctrl.saveError() ? m('div.bg-red.white.pa2.mb2', ctrl.saveError()) : null,
    m(pathHeader, {
      ancestors: ctrl.dashboard().path,
      record: ctrl.fakeNode(),
      class: '.flex.flex-wrap',
      helpIcon: true,
      helpFileName: 'locationPermissions.md',
      helpModalTitle: 'Permissions Help',
    }),
   m(paginationWithSearch, {
    data: ctrl.permissions(),
    newNode: ctrl.newNode,
    dataToShow: ctrl.permissionsToShow,
    placeHolder: 'Search group',
    itemsPerPage: 30,
    fieldsToSearch: ['groupName']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              m('colgroup', [
                m('col', {width: '30%'}),
                m('col', {width: '60%'}),
                m('col', {width: '10%'}),
              ]),
              m('thead', [
                m('tr', [ 
                  m('th.ph0.tl', 'Name'),
                  m('th.ph0.tl', 'Permissions'),
                  m('th.ph0.tl.ph2', 'Actions'),
                ])
              ]),
              m('tbody', [
                ctrl.permissionsToShow.map(function (permission) {
                  if (!permission['@rid']) {
                    return m('tr', [
                      m('td.tl.nowrap', [
                        m('label',{style:{'visibility':'hidden'}}, 'No Data')
                      ]),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                    ])
                  } else {
                    const permissionsByClass = {};
                    Object.entries(permission).forEach(([key, value]) => {
                      const processedKey = key.startsWith("parent") ? key.replace("parent", "") : key;

                      if (value === 1 && (processedKey.endsWith("Read") || processedKey.endsWith("Write"))) {
                        const className = processedKey.replace("Read", "").replace("Write", "");
                        const permissionType = processedKey.endsWith("Read") ? "R" : "W";
                        
                        if (!permissionsByClass[className]) {
                          permissionsByClass[className] = [];
                        }
                        if (permissionsByClass[className].indexOf(permissionType) === -1) {
                          permissionsByClass[className].push(permissionType);
                        }
                      }
                    });

                    const sortedPermissions = Object.entries(permissionsByClass)
                      .sort(([classNameA, permissionsA], [classNameB, permissionsB]) => {
                        // Sort based on the number of permissions
                        const aScore = (permissionsA.includes("W") ? 1 : 0) + (permissionsA.includes("R") ? 2 : 0);
                        const bScore = (permissionsB.includes("W") ? 1 : 0) + (permissionsB.includes("R") ? 2 : 0);
                        // Higher score first
                        if (bScore !== aScore) {
                          return bScore - aScore; // Primary sorting by score
                        }
                        // Secondary sorting alphabetically by className
                        return classNameA.localeCompare(classNameB);
                    });

                    const permissionString = sortedPermissions
                      .map(([className, permissions]) => `${className} (${permissions.join(" + ")})`)
                      .join(", ");
                    return m('tr', [
                      m('td.tl.nowrap', [
                        m(m.route.Link, {
                          href: `/group/${permission.in['@rid'].slice(1)}`
                        }, permission.in.name)
                      ]),
                      m('td.tl.nowrap.truncate', {style: {maxWidth: '1px'}},permissionString),
                      m('td.tl', [
                        m(rowActionDropdown, {
                          items: [
                            {
                              label: 'Edit Permission',
                              icon: 'ion-ios-compose',
                              onclick: groupPermissionModal.editDialogue.bind(groupPermissionModal, permission)
                            },
                            {
                              label: 'Delete Permission',
                              icon: 'ion-ios-trash',
                              class: 'red',
                              onclick: groupPermissionModal.deleteDialogue.bind(groupPermissionModal, permission)
                            }
                          ]
                        })
                      ])
                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    m(buttonElement, {
      label: 'Add Group',
      func: permissionModal.editDialogue.bind(permissionModal, {
        dashboard: ctrl.dashboard()['@rid'],
        read: 0,
        write: 0,
        existingGroupRids: permissionGroupFilter.existingGroupRidsFromPermissions(ctrl.permissions())
      }),
      class: 'btn-default icon-right mt3'
    }),
  ])
}


module.exports = page;
